export class GroupReportModuleCount {
    status?: ('active'|'inactive');
    count?: number;

    static fromJson(fields: any): GroupReportModuleCount {
        let item = Object.assign(new this(), fields);
        return item;
    }
}
